import request from '@/utils/request'

export function getBoard() {
    return request({
        url: '/gain/search/form/board',
        method: 'get'
    })
}

export function getAdmin() {
    return request({
        url: '/gain/search/form/admin',
        method: 'get'
    })
}